import { render, staticRenderFns } from "./page-layout-wine-faqs-list.vue?vue&type=template&id=142eb8dc&scoped=true"
import script from "./page-layout-wine-faqs-list.vue?vue&type=script&lang=js"
export * from "./page-layout-wine-faqs-list.vue?vue&type=script&lang=js"
import style0 from "./page-layout-wine-faqs-list.vue?vue&type=style&index=0&id=142eb8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142eb8dc",
  null
  
)

export default component.exports